import { useEffect, useState } from "react";

export const useCheckMobileScreen = (widthSize?: number) => {
    const [width, setWidth] = useState(window.innerWidth);
    const handleWindowSizeChange = () => {
        setWidth(window.innerWidth);
    };

    useEffect(() => {
        window.addEventListener("resize", handleWindowSizeChange);
        return () => {
            window.removeEventListener("resize", handleWindowSizeChange);
        };
    }, []);

    return widthSize ? width <= widthSize : width <= 768;
};
